import DB from '../../DAL/DB'

const locks = new DB.ProjectLocks()

export default async function breakLock (id) {
  await locks.delete(id)
}